import React from "react";
import PrizeList from "./prizeList";
import { TournamentResponse } from "../../../../api/tournament";
import { Timer1NoticeWrapper } from "../styles";

interface RightWrapperProps {
  data: TournamentResponse | null;
  subPrizeFont: number;
}

const RightDisplay: React.FC<RightWrapperProps> = ({ data, subPrizeFont }) => {
  return (
    <div className="right-wrapper">
      <PrizeList data={data} subPrizeFont={subPrizeFont} />
      <Timer1NoticeWrapper>
        <div
          className="value"
          dangerouslySetInnerHTML={{
            __html: data?.notice ? data.notice.replace(/\n/g, "<br />") : "",
          }}
        ></div>
      </Timer1NoticeWrapper>
    </div>
  );
};

export default RightDisplay;
